module.exports = __webpack_public_path__ + "static/visual_1-543780a9c913ad315602b6852f82348c.jpg";